<script>
import {useMenuStore} from "@js/store/MenuStore.js";
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue";
import {Link} from "@inertiajs/vue3";
import {onBeforeUnmount, onMounted, ref, watch} from "vue";
import {router} from '@inertiajs/vue3';
import ColorCircle from "@js/components/Statuses/ColorCircle.vue";

export default {
    name: "TopBarCatalogDropdown",
    components: {ColorCircle, IconAngleLeft, Link},
    methods: {
        buildMenuLink(item) {
            let url = this.route(item.route_name, { category_title: item.route_params.category_title });

            if (item.route_params.query) {
                const queryParams = new URLSearchParams();

                for (const [key, values] of Object.entries(item.route_params.query)) {
                    queryParams.append(key, JSON.stringify(values));
                }

                url += '?' + queryParams.toString();
            }

            return url;
        }
    },
    setup() {
        const menuStore = useMenuStore()

        const menuRef = ref(null)

        const handleClickOutside = (event) => {
            if (menuStore.isMenuCatalogOpen) {
                if (menuRef.value && !menuRef.value.contains(event.target)) {
                    menuStore.isMenuCatalogOpen = false
                }
            }
        }

        // Следим за isMenuCatalogOpen и вешаем/снимаем обработчик
        watch(
            () => menuStore.isMenuCatalogOpen,
            (isOpen) => {
                if (isOpen) {
                    setTimeout(function () {
                        document.addEventListener("click", handleClickOutside)
                    }, 50)
                } else {
                    document.removeEventListener("click", handleClickOutside)
                }
            }
        )

        // На всякий случай удалим обработчик при размонтировании компонента
        onBeforeUnmount(() => {
            menuStore.isMenuCatalogOpen = false
        })

        // При переходе страницы закрываем меню
        router.on("before", (event) => {
            menuStore.isMenuCatalogOpen = false
        })

        return {menuStore, menuRef}
    }
}
</script>

<template>
    <nav v-show="menuStore.isMenuCatalogOpen" ref="menuRef"
         class="absolute z-10 right-0 left-0 bg-white border-gray-200">
        <div class="mt-1 bg-white border-gray-200 shadow-xs border-y">
            <div class="container">
                <div class="flex flex-row divide-x w-full">
                    <div class="min-w-[300px]">
                        <Link v-for="(category, key) in menuStore.menuItems"
                              @mouseenter="menuStore.changeActiveCatalogMenu(key)"
                              :href="route(category.route_name, category.route_params ?? {})">
                            <div class="py-4 pe-5 ps-2 md:hover:bg-grayBg"
                                 :class="{'bg-grayBg': menuStore.activeCatalog === key}">
                                <div class="flex items-center justify-between text-[15px]">
                                    {{ category.title }}
                                    <IconAngleLeft class="rotate-180"/>
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div class="ps-5 py-5 w-full" v-show="menuStore.menuItems[menuStore.activeCatalog]">
                        <div class="grid grid-cols-3 gap-5">
                            <div v-for="sub_menu in menuStore.menuItems[menuStore.activeCatalog].sub_menu">
                                <div class="border-b pb-2 mb-2">
                                    <div class="text-xl">
                                        {{ sub_menu.title }}
                                    </div>
                                </div>
                                <div class="flex flex-col gap-1">
                                    <Link v-for="sub_menu in sub_menu.sub_menu"
                                          :href="buildMenuLink(sub_menu)"
                                          class="flex items-center gap-2 text-sm md:hover:text-navHoverColor transition">
                                        <span v-if="sub_menu.country_code">
                                            <img v-if="sub_menu.country_code"
                                                 :src="'/assets/flags/' + sub_menu.country_code+'.svg'" title="flag"
                                                 alt="flag"
                                                 class="h-3 w-4 rounded object-cover"/>
                                        </span>
                                        <ColorCircle v-if="sub_menu.hex" :hex="sub_menu.hex"/>
                                        {{ sub_menu.title }}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<style scoped lang="scss">

</style>
